import type { FluentIcon } from '@fluentui/react-icons'
import { ShieldTaskRegular, PersonKeyRegular, LaptopRegular, BranchForkRegular } from '@fluentui/react-icons'

export interface CoverageItem {
  id: string
  label: string
  detail: string
  icon: FluentIcon
}

/** Compact coverage summary used in the sidebar. */
export const investigationCoverage: CoverageItem[] = [
  {
    id: 'incident',
    label: 'Incident intelligence',
    detail: 'Sentinel + Defender XDR',
    icon: ShieldTaskRegular,
  },
  {
    id: 'identity',
    label: 'Identity investigation',
    detail: 'Entra ID Protection + Sign-ins',
    icon: PersonKeyRegular,
  },
  {
    id: 'endpoint',
    label: 'Endpoint investigation',
    detail: 'Microsoft Defender for Endpoint',
    icon: LaptopRegular,
  },
  {
    id: 'correlation',
    label: 'Cross-domain correlation',
    detail: 'Identity × Endpoint × Incident',
    icon: BranchForkRegular,
  },
]

export interface CapabilityLayer {
  id: string
  ordinal: string
  title: string
  points: string[]
}

/** Full capability layers shown on the Capabilities panel. */
export const capabilityLayers: CapabilityLayer[] = [
  {
    id: 'incident',
    ordinal: '01',
    title: 'Incident Investigation',
    points: [
      'Sentinel / Defender XDR incident resolution',
      'Incident alerts',
      'Incident entities',
      'Tactics and techniques',
      'Downstream investigation routing',
    ],
  },
  {
    id: 'identity',
    ordinal: '02',
    title: 'Identity Investigation',
    points: [
      'Entra risky user context',
      'Identity Protection',
      'Sign-ins',
      'MFA',
      'Conditional Access context',
    ],
  },
  {
    id: 'endpoint',
    ordinal: '03',
    title: 'Endpoint Investigation',
    points: [
      'Defender device posture',
      'Endpoint alerts',
      'Process activity',
      'Network activity',
      'Logon activity',
      'Telemetry coverage',
    ],
  },
  {
    id: 'correlation',
    ordinal: '04',
    title: 'Cross-domain reasoning',
    points: ['Correlation', 'Attack-path analysis', 'Evidence gaps', 'Risk assessment'],
  },
]
